//paymentSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  verifyRazorpayPayment,
  fetchPaymentTransactions,
} from "../../utilities/services/payment";

// Async thunk for verifying payment
export const verifyPayment = createAsyncThunk(
  "payment/verifyPayment",
  async (paymentDetails, { rejectWithValue }) => {
    try {
      const response = await verifyRazorpayPayment(paymentDetails);
      return response; // Return server response
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Payment verification failed"
      );
    }
  }
);

// Async thunk for fetching payment transactions
export const fetchPaymentTransactionsThunk = createAsyncThunk(
  "payment/fetchTransactions",
  async ({ userId, dateRange ,start_date,end_date}, { rejectWithValue }) => {
    try {
      const transactions = await fetchPaymentTransactions(userId, dateRange,start_date,end_date);
      return transactions; // Return the fetched transactions
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch transactions");
    }
  }
);


const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    verificationStatus: "idle", // idle, loading, succeeded, failed
    verificationError: null,
    verifiedPayment: null, // Store verified payment data
    transactions: [], // Store payment transactions
    transactionsStatus: "idle", // idle, loading, succeeded, failed
    transactionsError: null, // Store error message if fetching transactions fails
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Payment verification cases
      .addCase(verifyPayment.pending, (state) => {
        state.verificationStatus = "loading";
        state.verificationError = null;
      })
      .addCase(verifyPayment.fulfilled, (state, action) => {
        state.verificationStatus = "succeeded";
        state.verifiedPayment = action.payload;
      })
      .addCase(verifyPayment.rejected, (state, action) => {
        state.verificationStatus = "failed";
        state.verificationError = action.payload;
      })

      // Fetching payment transactions cases
      .addCase(fetchPaymentTransactionsThunk.pending, (state) => {
        state.transactionsStatus = "loading";
        state.transactionsError = null;
      })
      .addCase(fetchPaymentTransactionsThunk.fulfilled, (state, action) => {
        state.transactionsStatus = "succeeded";
        state.transactions = action.payload;
      })
      .addCase(fetchPaymentTransactionsThunk.rejected, (state, action) => {
        state.transactionsStatus = "failed";
        state.transactionsError = action.payload;
      });
  },
});

export default paymentSlice.reducer;
